export default __webpack_public_path__ + "static/media/vert-logo.89d17e09.png";